import {css} from "styled-components";

const borderStyle = css`
  border: solid .5px #BCBCBC;
  border-radius: 6px;
`;

export default borderStyle;
